









































import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import AlertsTable from '@/modules/alert/components/AlertsTable.vue';
import { alertApi } from '@/modules/alert/alert.api';
import { breadcrumbApi } from '@/modules/breadcrumb/breadcrumb.api';
import { deviceApi } from '@/modules/device/device.api';
import { userApi } from '@/modules/user/user.api';
import { SocketIOService } from '@/socketio.service';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    Tiles,
    CardWidget,
    CardComponent,
    AlertsTable,
  },
})
export default class Home extends Vue {
  public alertsCount = 0;
  public devicesCount = 0;
  public subscribersCount = 0;
  public inProgressBreadcrumbsCount = 0;

  public alertListener = (): void => {
    this.alertsCount++;
  }

  public get titleStack(): string[] {
    return ['Admin', 'Tableau de bord'];
  }

  public async getAlertsCount(): Promise<void> {
    this.alertsCount = await alertApi.getCount();
  }
  public async getDevicesCount(): Promise<void> {
    this.devicesCount = await deviceApi.getCount();
  }
  public async getSubscribersCount(): Promise<void> {
    this.subscribersCount = await userApi.getCount({ subscribers: true });
  }
  public async getBreadcrumbsInProgressCount(): Promise<void> {
    this.inProgressBreadcrumbsCount = await breadcrumbApi.getCount({
      inProgress: true,
    });
  }

  public created(): void {
    this.getAlertsCount();
    this.getDevicesCount();
    this.getSubscribersCount();
    this.getBreadcrumbsInProgressCount();
  }

  public mounted(): void {
    SocketIOService.sockets.backend.on('alert', this.alertListener);
  }
  public beforeDestroy(): void {
    SocketIOService.sockets.backend.off('alert', this.alertListener);
  }
}
